<div class="puzzleMask" (mouseup)="touchEnd($event)" (mousemove)="touchMove($event)" (touchmove)="touchMove($event)" (touchend)="touchEnd($event)"></div>
<div class="slideWhole" style="position:relative">
  <div class="puzzleBox">
    <div class="puzzleBase"><img width="300" height="150" src=""></div>
    <div class="refreshIcon" (click)="reset()">
      <i-tabler class="tb-icon tb-icon-m center" name="reload"></i-tabler>
    </div>
    <div class="puzzleBefore"><img width="64" height="64" src=""></div>
  </div>
  <div class="sliderContainer">
    <div class="sliderMask">
      <div class="slider" (touchstart)="touchStart($event)" (touchmove)="touchMove($event)" (touchend)="touchEnd($event)"
           (mousedown)="touchStart($event)" (mouseup)="touchEnd($event)" (mousemove)="touchMove($event)">
        <i-tabler class="sliderIcon b-icon tb-icon-m center" [name]="notMatch ? 'clock-cancel' : 'arrow-narrow-right'"></i-tabler>
      </div>
    </div>
    <span class="sliderText">Trượt để hoàn thiện mảnh ghép</span>
  </div>
</div>
